var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSucess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#03903e",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(16,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.028,6.22l-1.755,-1.169l-0.019,-0.535l-6.254,6.191l-2.707,-2.707l0.707,-0.707l2,2l6.205,-6.136l-0.008,-0.213l-2.104,-0.134l-1.12,-1.787l-1.89,0.936l-1.863,-0.987l-1.169,1.755l-2.107,0.076l-0.134,2.104l-1.787,1.12l0.936,1.89l-0.987,1.863l1.755,1.169l0.076,2.107l2.104,0.134l1.12,1.787l1.89,-0.936l1.863,0.987l1.169,-1.755l2.107,-0.076l0.134,-2.104l1.787,-1.12l-0.936,-1.89z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSucess);
export default __webpack_public_path__ + "static/media/icon-sucess.b907884211a8c538aa4c201e8a053ef1.svg";
export { ForwardRef as ReactComponent };